import { isEmpty } from 'lodash-es';
import { CampaignTemplate, DomainDetail, Profile, ValidEmail, DomainOwner } from '@dev/ee-api/ee-api-models';
import { OptionProps } from './SendTo/SendToInterface';

export const isCampaignTemplateSet = (campaignTemplate?: CampaignTemplate): boolean => !!campaignTemplate?.TemplateName;

export const getNameFromProfile = (profile: Profile): string => {
    if (!!profile.Company) {
        return profile.Company;
    }
    if (!!profile.FirstName && !!profile.LastName) {
        return `${profile.FirstName} ${profile.LastName}`;
    }
    return profile.FirstName;
};

export const isAllContactsOptionSelected = (chosenOptions: OptionProps[]): boolean =>
    !isEmpty(chosenOptions.filter((value: OptionProps) => value.isAllContacts));

export const isDomainVerified = (domain: DomainDetail): boolean => !!domain?.Spf;

export const isOwnDomain = (domain: DomainDetail): boolean => domain.Ownership === DomainOwner.Current;

export const isEmailVerified = (email: ValidEmail): boolean => !!email.Validated;

export const hasEmailUnallowedChars = (email: string): boolean => {
    const unallowedEmailChars = /[;,\s]/g;
    return unallowedEmailChars.test(email);
};
